// extracted by mini-css-extract-plugin
module.exports = {"link":"allocatedLink_link__4t-pY"};